export const F2FPaymentStatus = Object.freeze({
  NOT_FOUND: "NOT_FOUND",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  DENIED: "DENIED"
});
